import React, { FC } from 'react'
import Head from 'next/head'
import { NextSeo } from 'next-seo'
import { createResource, useResource } from '@/lib/i18n'
import { useRouter } from 'next/router'
import { useCurrentLanguage } from '@/lib/current-language'
import { getPathUrl } from '@/lib/utils'

const resource = createResource({
  en: {
    home: 'Apply for Easy & Quick Cash Loans Online | KreditPintar',
    product: ' Product Guide - Easy & Quick Cash Loans Online | KreditPintar',
    faq: 'FAQ - Easy & Quick Cash Loans Online | KreditPintar',
    guide: 'Guide - Easy & Quick Cash Loans Online | KreditPintar',
    aboutUs: 'About Us of Smart Credit, Quick Cash Loans Online | KreditPintar',
    education: 'Smart Credit, Quick Cash Loans Online | KreditPintar Blog',
    privacyPolicy: 'Privacy Policy of Smart Credit, Quick Cash Loans Online | KreditPintar',
    termsOfService: 'Terms Of Service of Smart Credit, Quick Cash Loans Online | KreditPintar',
    siteMap: 'SiteMap of Smart Credit, Quick Cash Loans Online | KreditPintar',
    career: 'Career of Smart Credit, Quick Cash Loans Online | KreditPintar',
    disclaimer: 'Disclaimer of Smart Credit, Quick Cash Loans Online | KreditPintar',
    attention: 'Attention of Smart Credit, Quick Cash Loans Online | KreditPintar',
    pintarScore: 'Guide - Easy & Quick Cash Loans Online | KreditPintar',
    pintarShop: 'Product Guide - Easy & Quick Cash Loans Online | KreditPintar',
    event: 'Event | KreditPintar',
    riplay: 'RIPLAY | KreditPintar',
  },
  id: {
    home: 'Aplikasi Instan Pinjaman Online Tunai | KreditPintar',
    product: 'Produk Pinjaman Online Tunai | KreditPintar',
    faq: 'FAQ | Pertanyaan Seputar Pinjaman Online Tunai Kredit Pintar',
    guide: 'Guide | Pertanyaan Seputar Pinjaman Online Tunai Kredit Pintar',
    aboutUs: 'Tentang Kami - Aplikasi Pinjaman Online Tunai | KreditPintar',
    education: 'Aplikasi Pinjaman Online Tunai | KreditPintar Blog',
    privacyPolicy: 'Kebijakan pribadi - Aplikasi Pinjaman Online Tunai | KreditPintar',
    termsOfService: 'Persyaratan layanan - Aplikasi Pinjaman Online Tunai | KreditPintar',
    siteMap: 'SiteMap - Aplikasi Pinjaman Online Tunai | KreditPintar',
    career: 'Career - Aplikasi Pinjaman Online Tunai | KreditPintar',
    disclaimer: 'Disclaimer - Aplikasi Pinjaman Online Tunai | KreditPintar',
    attention: 'Attention - Aplikasi Pinjaman Online Tunai | KreditPintar',
    pintarScore: 'Guide | Pertanyaan Seputar Pinjaman Online Tunai Kredit Pintar',
    pintarShop: 'Produk Pinjaman Online Tunai | KreditPintar',
    event: 'Event | KreditPintar',
    riplay: 'RIPLAY | KreditPintar',
  },
})

interface IProps {
  metaTitle?:
    | 'home'
    | 'product'
    | 'aboutUs'
    | 'faq'
    | 'education'
    | 'siteMap'
    | 'privacyPolicy'
    | 'termsOfService'
    | 'career'
    | 'guide'
    | 'attention'
    | 'disclaimer'
    | 'pintarShop'
    | 'pintarScore'
    | 'event'
    | 'riplay'
  description?: string
  openGraphFlag?: boolean
  showAd?: boolean
}

const KPHead: FC<IProps> = (props: IProps) => {
  const { metaTitle, description, showAd = false, openGraphFlag = true } = props
  const { t } = useResource(resource)
  const router = useRouter()
  const { language: lng } = useCurrentLanguage()
  const { asPath } = router
  const env = process.env.NEXT_PUBLIC_HOST_URL
  // const hideAds = asPath.match('isFrom=notification')?.length > 0
  const canonical = lng !== 'id' ? `${env}/en-us${getPathUrl(asPath)}` : `${env}${getPathUrl(asPath)}`

  // useEffect(() => {
  //   if (process.env.NEXT_PUBLIC_ENV === 'production' && showAd && !hideAds) {
  //     setTimeout(
  //       () =>
  //         loadScript('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1003834598940152'),
  //       0,
  //     )
  //   }
  // }, [])

  return (
    <>
      <Head>
        <title> {metaTitle ? `${t(metaTitle)}` : 'KreditPintar'} </title>
        <link ref="icon" href="/favicon.ico" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link rel="dns-prefetch" href="https://fonts.gstatic.com" />
        <link rel="dns-prefetch" href="https://static.kreditpintar.net" />
        <link rel="dns-prefetch" href="https://static.kreditpintar.com" />
        <link rel="dns-prefetch" href="https://pagead2.googlesyndication.com" />
        <link rel="dns-prefetch" href="https://pintardiscover.wpcomstaging.com" />
        <link rel="dns-prefetch" href="https://www.googletagmanager.com" />
        <link rel="dns-prefetch" href="https://googleads.g.doubleclick.net" />
        <link rel="dns-prefetch" href="https://partner.googleadservices.com" />
        <link rel="dns-prefetch" href="https://www.google.com.ph" />
        <link rel="dns-prefetch" href="https://adservice.google.com.ph" />
        <link rel="dns-prefetch" href="https://fonts.googleapis.com" />
        <link rel="dns-prefetch" href="https://tpc.googlesyndication.com" />
        <link rel="dns-prefetch" href="https://analytics.google.com" />
        <link rel="dns-prefetch" href="https://lh3.googleusercontent.com" />
        <link rel="dns-prefetch" href="https://lh4.googleusercontent.com" />
        <link rel="dns-prefetch" href="https://lh5.googleusercontent.com" />
        <link rel="dns-prefetch" href="https://lh6.googleusercontent.com" />
        <link rel="dns-prefetch" href="https://widgets.wp.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,100..900&display=swap"
          rel="stylesheet"
        />

        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
      </Head>
      <NextSeo
        title={metaTitle ? `${t(metaTitle)}` : 'KreditPintar'}
        canonical={canonical ? canonical : ''}
        description={description}
        openGraph={
          openGraphFlag
            ? {
                site_name: 'Best Cash Loans Online in Indonesia | KreditPintar',
                locale: 'id',
                type: 'website',
                url: canonical,
                title: 'Best Cash Loans Online in Indonesia | KreditPintar',
                description: description,
                images: [{ url: `${process.env.NEXT_PUBLIC_HOST_URL}/logo.png`, alt: 'KreditPintar' }],
              }
            : {}
        }
        languageAlternates={
          asPath.indexOf('/education') !== -1
            ? []
            : [
                { href: `${process.env.NEXT_PUBLIC_HOST_URL}${router.asPath}`, hrefLang: 'id' },
                { href: `${process.env.NEXT_PUBLIC_HOST_URL}/en-us${router.asPath}`, hrefLang: 'x-default' },
              ]
        }
      />
    </>
  )
}

export default KPHead
